module.exports = __webpack_public_path__ + "img/nature-2.8a87e7c5.jpg";